/**
 * Clamps a value (makes sure it's always between min and max)
 * @param value
 * @param min
 * @param max
 */
export default function (value, min, max) {
    return Math.min(max, Math.max(min, value));
}
